import { BackendModel, BackendService } from '../core/backend.service';

export class TiposEnvio extends BackendModel {

  static path = '/tipos-envio/';

  id: number;
  description: string;
  costo: number;

  constructor(protected backendService: BackendService, model?: TiposEnvio) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/tiposEnvio/tiposEnvio.model.ts